const colors = {
  wtf: "rgb(var(--wtf) / <alpha-value>)",
  icon: {
    default: "#EEEEF0",
  },

  text: {
    warning: "#E5484D",
    primary: "#EEEEF0",
    secondary: "#99969E",
    tertiary: "#7C7A85",
    brand: "#776ADC",
  },

  brand: {
    dark: {
      9: "#6E56CF",
      10: "#7C66DC",
    },
  },

  grey: {
    dark: {
      0: "#0E0D0F",
      3: "#232225",
      5: "#323035",
      6: "#3C393F",
      11: "#99969E",
    },
  },

  green: {
    dark: {
      9: "#30A46C",
    },
  },

  button: {
    label: {
      primary: "#EEEEF0",
    },
    background: {
      secondary: "#232225",
      primary: "#6D28D9",
      error: "#E5484D",
    },
  },

  input: {
    background: {
      active: "#1A191B",
    },
    border: {
      default: "#49474E",
      active: "#625F69",
    },
    text: {
      default: "#6F6D78",
    },
    icon: {
      default: "#7C7A85",
    },
  },

  divider: {
    strong: "#2B292D",
  },

  tag: {
    default: "#323035",
  },

  surface: {
    secondary: "#1A191B",
    primary: "#0E0D0F",
    tertiary: "#232225",
  },
};

module.exports.colors = colors;
